<template>
	<div class="display-flex flex-row flex-wrap flex-align-center">
		<div v-for="item in allCalculatedDirectoryApps" :key="item.id">
			<PreviouslySelectedFavoriteAppItem
				class="mr-n1"
				:id="item?.id"
				:icon="item?.icon"
				:tooltipText="getToolTipText(item)"
				:cantDelete="Boolean(item.cantDeleteReason)"
			/>
		</div>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
import { getAllDirectoryApps } from '@/store/modules/apps/actions';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { CANT_DELETE_APP_ERRORS } from '@/views/AppLayout/ManageAndCreate/create-and-manage.const.js';
import { allCalculatedDirectoryApps, allCalculatedDirectoryAppsIds } from '@/store/modules/auth/getters.js';
import PreviouslySelectedFavoriteAppItem from '@/components/SelectFavoriteApps/PreviouslySelectedFavoriteAppItem.vue';
export default {
	name: 'PreviouslySelectedFavoriteApps',
	components: { PreviouslySelectedFavoriteAppItem },
	computed: {
		...mapGettersShorthand({ allCalculatedDirectoryApps, allCalculatedDirectoryAppsIds }),
	},
	methods: {
		...mapActions(['getUserCalculatedFavoriteApps']),
		...mapActionsShorthand({ getAllDirectoryApps }),
		getToolTipText(item) {
			return item.cantDeleteReason
				? `${item?.service_name} - ${CANT_DELETE_APP_ERRORS[item.cantDeleteReason]}`
				: `Remove ${item?.service_name}`;
		},
	},
	created() {
		this.getUserCalculatedFavoriteApps();
	},
	watch: {
		allCalculatedDirectoryAppsIds: {
			handler(specificIds) {
				if (specificIds?.length) {
					this.getAllDirectoryApps({ specificIds });
				}
			},
			immediate: true,
		},
	},
};
</script>
<style lang="scss" scoped></style>
